import { ConnectToDeployerData } from '../../../types/connect-to-deployer-data';
import { UpdateServerLocationResponse } from '../../deployerGrid/types/deployer-grid-responses';
import { PackageActionContext } from '../../types/PackageActionContext';
import { DeployerRelayData } from '../../deployerGrid/types';
import { PackageData } from '../../../types/package-data';

export const CONNECT_TO_DEPLOYER_OPTIONS: ConnectToDeployerData[] = [
  {
    value: 1,
    title: 'Bitdefender Cloud',
  },
  {
    value: 2,
    title: 'Endpoint Security Relay',
  },
  {
    value: 3,
    title: 'GravityZone Appliance',
  },
];

export enum DeployType {
  BitdefenderCloud = 0,
  EndpointSecurityRelay = 1,
  GravityZoneAppliance = 2,
}

export const DEFAULT_SUPA_PORT = 7074;

export interface DeployerDataResponse {
  updateLocation: string;
  settings: {
    ecsHostname: string;
    useCustomECS: boolean;
    supaId?: string;
    deployType: number;
  };
}

export interface DeployerFormViewMetadata {
  updateLocationData: UpdateServerLocationResponse;
  context: PackageActionContext;
  companySuperAgents: DeployerRelayData[];
  packageData: PackageData;
  isInstallAgentDeployer: boolean;
}
